import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { VacationVoucher } from './VacationVoucher';

export const VoucherModal = ({ request, open, onOpenChange }) => {
  if (!request) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Comprobante de Vacaciones</DialogTitle>
        </DialogHeader>
        <VacationVoucher request={request} />
      </DialogContent>
    </Dialog>
  );
};
